import React, { useEffect, useState } from 'react';
import styles from './RightSidebarMenu.module.scss';
import RightSidebarHeader from '../../../../../../components/RightVideoActionMenu/RightSidebarHeader';
import { useLibraryContext } from '../../../../../../context/LibraryContext';
import conf from '../../../../../../../../conf';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../../../../../../components/Button/Button';
import CmsAPI from '../../../../../../../common/apis/CmsAPI';
import ConfirmApprovalsCommentModal from '../../../../../../components/ConfirmApprovalsCommentModal/ConfirmApprovalsCommentModal';
import ApproverInfo from '../../../../../../components/ApproverInfo/ApproverInfo';
import CommentsTab from '../../../../../../components/CommentsTab/CommentsTab';

const commentInit = {
  authorName: '',
  content: '',
  parent: null,
  type: 2,
  username: '',
};

const approvalTypes = {
  approve: 'approve',
  decline: 'decline',
  revoke: 'revoke',
};

const config = conf[process.env.APP_CONF];
const commentsType = 2;

const RightSidebarMenu = ({ isPendingForReview, isApproved }) => {
  const [approvalsComments, setApprovalsComments] = useState([]);
  const [isApprovalsCommentsLoading, setIsApprovalsCommentsLoading] = useState(false);

  const [newComment, setNewComment] = useState(commentInit);
  const [isShowCommentConfirmationModal, setIsShowCommentConfirmationModal] = useState(false);
  const [approvalType, setApprovalType] = useState(null);

  const { selectedCard, toggleApproveVideo, toggleDeclineVideo, toggleRevokeVideo } = useLibraryContext();

  const { t } = useTranslation();

  useEffect(() => {
    getApprovalsComments();
  }, [selectedCard]);

  const getApprovalsComments = async () => {
    try {
      setIsApprovalsCommentsLoading(true);
      const { result } = await CmsAPI.getComments(Object.keys(selectedCard)[0], commentsType);
      setApprovalsComments(result || []);
    } catch (err) {
      console.log(err);
    } finally {
      setIsApprovalsCommentsLoading(false);
    }
  };

  const handleApproveVideo = () => {
    if (newComment.content) {
      setApprovalType(approvalTypes.approve);
      setIsShowCommentConfirmationModal(true);
      return;
    }

    toggleApproveVideo();
  };

  const handleDeclineVideo = () => {
    if (newComment.content) {
      setApprovalType(approvalTypes.decline);
      setIsShowCommentConfirmationModal(true);
      return;
    }

    toggleDeclineVideo();
  };

  const handleRevokeVideo = () => {
    if (newComment.content) {
      setApprovalType(approvalTypes.revoke);
      setIsShowCommentConfirmationModal(true);
      return;
    }

    toggleRevokeVideo();
  };

  return (
    <div className={styles.rightSidebarContainer}>
      <div className={styles.wrapper}>
        <div className={styles.descriptionWrapper}>
          <RightSidebarHeader selectedVideos={Object.keys(selectedCard).length} />
          {Object.keys(selectedCard).length === 1 && (
            <>
              {Object.values(selectedCard)[0].reviewer && (
                <div className={styles.approverContainer}>
                  <ApproverInfo
                    img={Object.values(selectedCard)[0].reviewer?.avatar}
                    fullName={Object.values(selectedCard)[0].reviewer?.name}
                  />
                </div>
              )}
              <div className={styles.commentsContainer}>
                <CommentsTab
                  updateComments={getApprovalsComments}
                  isCommentsLoading={isApprovalsCommentsLoading}
                  storyId={Object.keys(selectedCard)[0]}
                  comments={approvalsComments}
                  commentInit={commentInit}
                  newComment={newComment}
                  setNewComment={setNewComment}
                />
              </div>
            </>
          )}
        </div>
        <div className={styles.btnWrapper}>
          <div className={styles.line} />
          {isPendingForReview && (
            <>
              <CustomButton variant="primary" label={t('general.video_action_button.approve')} onClick={handleApproveVideo} />
              <CustomButton variant="secondary" label={t('general.video_action_button.decline')} onClick={handleDeclineVideo} />
            </>
          )}
          {isApproved && (
            <CustomButton variant="primary" label={t('general.video_action_button.revoke')} onClick={handleRevokeVideo} />
          )}
        </div>
        {isShowCommentConfirmationModal && (
          <ConfirmApprovalsCommentModal
            isShow={isShowCommentConfirmationModal}
            onClose={() => setIsShowCommentConfirmationModal(false)}
            approvalType={approvalType}
            approvalTypes={approvalTypes}
            approveVideo={toggleApproveVideo}
            declineVideo={toggleDeclineVideo}
            revokeVideo={toggleRevokeVideo}
          />
        )}
      </div>
    </div>
  );
};

export default RightSidebarMenu;
